import { useTranslation } from "react-i18next";

type PropsType = {
  page: any;
  prepareRow: any;
  getTableBodyProps: any;
};
const TableBody: React.FC<PropsType> = ({
  page,
  prepareRow,
  getTableBodyProps,
}) => {
  const { i18n } = useTranslation();

  return (
    <tbody {...getTableBodyProps()}>
      {page.map((row: any, index3: number) => {
        prepareRow(row);
        return (
          <tr key={index3} {...row.getRowProps()} className={``}>
            {row.cells.map((cell: any, index4: number) => {
              return (
                <td
                  {...cell.getCellProps()}
                  key={index4}
                  className={`${
                    i18n.language === "en" ? "pr-4" : "pl-4"
                  }  py-4 text-sm border-b tableBorder  px-4 `}
                  title={cell.value}
                >
                  {cell.column.Header === "action" ? (
                    cell.render("Cell")
                  ) : (
                    <div
                      className={`  relative  font-medium  text-sm w-auto    ${
                        cell.column.Header === "action"
                          ? ` text-center `
                          : `truncate`
                      }`}
                    >
                      {cell.render("Cell")}
                    </div>
                  )}
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  );
};
export default TableBody;
